// removed by extract-text-webpack-plugin
module.exports = {"realtorContact":"_1P6P_MrCoYL5_6apBXSlEL","logo":"_3MSdQskJHKC2WBxsy8T5Tz","logoPlaceholder":"_1VPRzlmysK6c4MGJQSSp_L","details":"_1kzV1ofS4tCsFoRIWDTE_n","realtorDetails":"uu7CNioG58nmdWG7iXDM-","textEllipsis":"_2uYJy8JDySS__Neg8qw3tU","text":"_3GTsJl30Ni5N_2QRyY1ChO","link":"wWO6KJIMFofudyJk6JiwG","status":"LrstmzbRYpN1FREVR3Usy","realtorName":"_33pm34BsN3th1bnSv9nIHE","realtorLicense":"_324j2ibEbRcl0V0mLGH48p"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BasicInformation/RealtorContact/RealtorContact.scss
// module id = 1717
// module chunks = 0